export default __webpack_public_path__ + "b9df5939473f7a9d3756ef998c92c701.svg";